import React from "react";
import { IconAttachment } from "../Icons";

export default function UserMessageItem({ event }) {
  const text = event.payload?.text || "";
  const attachments = event.payload?.attachments || [];
  return (
    <div className="ca-msg ca-msg--user">
      {attachments.length > 0 && (
        <div className="ca-msg-attachments">
          {attachments.map((a) => (
            <span key={a.file_id || a.path} className="ca-msg-attachment">
              <IconAttachment size={11} />
              <span>{a.filename}</span>
            </span>
          ))}
        </div>
      )}
      {text && (
        <div className="ca-msg-bubble">{text}</div>
      )}
    </div>
  );
}
